<div class="flex align-items-center justify-content-center px-3 py-5 border-bottom-1 surface-border bg-white" style="height:90px">
    <img src="assets/images/redur-logo.svg" style="height:65px" class="mb-2 mt-2">
</div>